export default {
  COMPANIES: {
    TITLE: 'Empresa',
    EDIT_TITLE: 'Datos de la Empresa',
    CREATE: {
      STEP_1: {
        HELLO: 'Hola {{ username }}, ',
        TITLE_CREATE: 'da de alta tu Empresa',
        SUBTITLE: 'Información de la Empresa',
        TITLE_EDIT: 'Actualiza los datos de tu Empresa',
        INFORMATION: 'Escribe la dirección y selecciona una sugerida del listado',
        COUNTRY: 'País',
        CIF: {
          DEFAULT: 'Identificación fiscal',
          ES: 'NIF',
          MX: 'RFC',
          US: 'EIN',
          UK: 'VAT',
          CA: 'BN',
          GB: 'VAT',
          FR: 'SIRET',
          IT: 'P.IVA',
          IE: 'VAT',
          DE: 'USt-IdNr',
          CO: 'NIT',
          AR: 'CUIT',
          CL: 'RUT',
          PE: 'RUC',
          GT: 'NIT',
          EC: 'RUC',
          SV: 'NIT',
          CR: 'Cédula Jurídica',
          DO: 'RNC',
          VE: 'RIF',
          BR: 'CNPJ',
        },
        NAME: 'Razón social / Nombre legal',
        BUSINESS_NAME: 'Nombre comercial',
        ADDRESS: 'Solo se aceptan direcciones de la lista',
        ADDRESS_PLACEHOLDER: 'Introduce la dirección de tu Empresa',
        CITY: 'Ciudad / Municipio',
        POSTAL_CODE: 'Código postal',
        STATE: 'Provincia / Estado',
        LOCATION_AUTO_PLACEHOLDER: 'Este campo se autocompleta',
        LOCATION_MANUAL_PLACEHOLDER: 'Completa este campo',
        LOCATION_OPTIONAL_PLACEHOLDER: 'Campo opcional',
        LOCATION_STATE_NOT_DETECTED_ERROR: 'Selecciona una dirección más precisa para que este campo se autocomplete.',
        WEB: 'Página web / Red social / Perfil en línea',
        NO_WEB: 'La empresa no tiene página web.',
        SECTOR: 'Sector / Industria',
        SIZE: 'Tamaño (Número de emplead@s)',
        LINKEDIN: 'Perfil de LinkedIn',
        LINKEDIN_HELP: 'LinkedIn de ej: https://linkedin.com/company/wokap',
        LOCATIONS: 'Ubicaciones',
        ADD_LOCATION: 'Añadir ubicación',
        NO_LINKEDIN: 'La Empresa no tiene perfil en LinkedIn.',
        TAGS_HELP: 'Presiona Coma o Enter para añadir una nueva etiqueta.',
        PLACEHOLDER: {
          NAME: 'Escribe la razón social',
          BUSINESS_NAME: 'Escribe el nombre comercial',
          WEB: 'Escribe la página web',
          LINKEDIN: 'Escribe el perfil de LinkedIn',
          CIF: 'Escribe la identificación fiscal',
          SECTOR: 'Selecciona el sector',
          SIZE: 'Selecciona el número de emplead@s',
        },
        DIALOG: {
          HEADER: 'Cancelar creación de Empresa',
          MESSAGE: '¿Estás segur@ de que deseas cancelar la creación de la Empresa? Los datos se perderán.',
          ACCEPT: 'Continuar',
          REJECT: 'Volver',
        },
      },
      STEP_2: {
        TITLE: 'Invita a otras personas del equipo para que puedan acceder y gestionar la cuenta de la empresa.',
        ADD_RESPONSIBLE: 'Añadir otr@ usuari@',
        RESPONSIBLE_NUMBER: 'Responsable',
        INVITE_PERMISSIONS_INFO_1: 'Puedes añadir usuari@s ahora o hacerlo más adelante, una vez dada de alta la empresa, desde “Gestión de usuari@s”.',
        INVITE_PERMISSIONS_INFO_2: 'Ten en cuenta que, si añades usuari@s ahora, todas las personas que des de alta tendrán acceso a todas las ofertas y sucursales.',
        INVITE_PERMISSIONS_INFO_3: 'Una vez dada de alta la empresa, podrás modificar, limitar o asignar permisos específicos a cada un@ desde “Gestión de usuari@s”.',
        PERMISSION_INFO_DESCRIPTION_1: 'Esta tabla muestra las acciones que pueden realizar l@s usuari@s según los distintos roles disponibles. Elige cuál asignar a las personas que te ayudarán a gestionar la cuenta de tu empresa.',
        SAVE_CARD: 'Guardar',
        SAVE_CARD_LABEL: 'Guardado',
        SAVE_ALL_BEFORE_CONTINUE: 'Hay un usuari@ sin guardar.<br class="block sm:hidden"> Elimínalo o guárdalo para continuar.',
        MAX_RESPONSIBLES_REACHED: 'En el registro puedes invitar hasta tres personas. Una vez creada la empresa, gestiona y añade l@s usuari@s que necesites en Gestión de usuari@s.',
        AUTHORIZED_PERSON: {
          FIRSTNAME: 'Nombre',
          LASTNAME: 'Apellidos',
          COMPANY_POSITION: 'Cargo en la Empresa',
          EMAIL: 'Email',
          PHONE: 'Número de teléfono',
          CONTACT_PHONE: 'Número de teléfono',
          PHONE_HELP: 'Número de teléfono ej: +34123456789',
          GROUP: { LABEL: 'Rol' },
        },
        PLACEHOLDER: {
          FIRSTNAME: 'Escribe el nombre',
          LASTNAME: 'Escribe los apellidos',
          COMPANY_POSITION: 'Escribe el cargo en la empresa',
          EMAIL: 'Escribe el email',
          GROUP: 'Selecciona el rol',
        },
        FOOTER: 'La notificación por correo puede llegar a la carpeta de spam; avísale a la persona invitada que la revise si no la encuentra en su bandeja principal.',
      },
      STEP_3: {
        TITLE: 'Información clave sobre la Empresa',
        SUBTITLE: 'Las siguientes 4 preguntas son clave, ya que representan la imagen de tu empresa al mundo, y serán la base para que wokap te ayude a diseñar tus ofertas de empleo.',
        PLACEHOLDER: { ANSWER: 'Escribe tu respuesta' },
        ENTITY_QUESTION_ONE: '¿Cuáles son los principales productos o servicios que ofrece la empresa?',
        ENTITY_QUESTION_TWO: '¿Qué hace única a la empresa? ¿Qué la distingue de otras en el mercado?',
        ENTITY_QUESTION_THREE: '¿Quiénes son sus consumidores, usuari@s o audiencias principales?',
        ENTITY_QUESTION_FOUR: '¿En qué regiones o países tiene presencia la empresa?',
        ENTITY_QUESTION_FIVE: '¿Cómo describirías el entorno, la cultura y el ambiente laboral en la empresa? (Opcional)',
        ENTITY_QUESTION_SIX: '¿Quieres añadir algo más que consideres importante sobre la empresa? (Opcional)',
      },
      STEP_4: {
        TITLE: 'Sube el logo de la Empresa',
        TERMS_LABEL: 'Confirmo que estoy autorizado por mi organización para crear y administrar esta cuenta, y acepto los',
        TERMS_LINK: 'Términos y Condiciones del Servicio',
        TERMS_LABEL_2: ' y el ',
        PRIVACY_LINK: 'Aviso de Privacidad',
        PRIVACY_LABEL_2: ', incluyendo el tratamiento de los datos proporcionados por la organización, así como el acceso, análisis, registro y gestión de la actividad dentro del SaaS de wokap —tanto la mía como la de cualquier usuari@ que se añada a esta cuenta— conforme a sus políticas. La organización es responsable de los usuarios que invite y del uso que estos hagan de los datos y herramientas del servicio.',
        AVATAR: {
          TITLE: 'Sube el logotipo',
          INFO: 'El logotipo debe ser de 200×200 px, en formato JPG o PNG.',
          BUTTON: 'Adjuntar',
          REPLACE_BUTTON: 'Reemplazar logotipo',
        },
      },
      STEP_5: {
        TITLE: 'Descripción de la Empresa',
        INFO: 'Hemos generado una descripción de <strong>{{name}}</strong> basada en la información proporcionada. Puedes editarla directamente o usar la IA para ajustarla.',
        DESCRIPTION: 'Descripción',
        EDIT: 'Editar',
        SAVE: 'Guardar',
        UNSAVED_DESCRIPTION_WARNING: 'La descripción está sin guardar.<br class="block sm:hidden"> Elimínala o guárdala para continuar.',
        PUBLIC_DESCRIPTION_LABEL: 'Permitir que la descripción sea pública, podrás cambiarlo en los ajustes de la empresa.',
        AI_PROMPT: {
          COMPANY_CHANGES: '¿Quieres hacer cambios en la descripción?',
          PLACEHOLDER: 'Ej: Hazla más formal, enfócate en nuestros valores, menciona que somos líderes en innovación...',
        },
        SUGGESTED_CHIPS: {
          DESCRIBE_COMPANY: 'Describe mejor nuestra empresa',
          USE_FORMAL_LANGUAGE: 'Usa un lenguaje más formal',
          SHORTER_AND_DIRECT: 'Hazla más corta y directa',
          PROFESSIONAL_TONE: 'Usa un tono más profesional',
          REMOVE_GENERICS: 'Elimina frases genéricas',
          EMPHASIZE_VALUES: 'Enfatiza nuestros valores',
          MENTION_SECTOR: 'Menciona nuestro sector específico',
          ADD_ACHIEVEMENTS: 'Añade nuestros logros',
          RELEVANT_AT_START: 'Lo más relevante al inicio',
        },
        LOADING: {
          GENERATING_DESCRIPTION: 'Generando descripción de tu empresa...',
          AI_INPUT_PLACEHOLDER: 'Espera un momento...',
        },
        ERRORS: {
          GENERATION_FAILED: 'No pudimos generar la descripción. Por favor, intenta de nuevo.',
          DESCRIPTION_REQUIRED: 'La descripción es obligatoria para completar el registro.',
          DESCRIPTION_MIN_LENGTH: 'La descripción debe tener al menos 10 caracteres.',
        },
        RETRY: 'Reintentar',
      },
    },
    EDIT: {
      UNSUBSCRIBE: 'Dar de baja',
      SUCCESS: 'Actualizada empresa correctamente.',
      DELETE_SUCCESS: 'Empresa dada de baja correctamente.',
      DELETE_SUCCESS_REDIRECT: 'Empresa dada de baja correctamente. Serás redirigido a la pantalla de inicio de sesión.',
      CROP_IMAGE: { TITLE: 'Recortar imagen' },
      DELETE_DIALOG: {
        HEADER: '¿Estás segur@ que quieres dar de baja tu empresa?',
        REASON_LABEL: 'Lamentamos que te vayas. Nos gustaría entender el motivo para mejorar:',
        REASON_REQUIRED: 'Debes seleccionar una de las opciones',
        REASONS: {
          OBJECTIVE_ACHIEVED: 'Ya contratamos / logramos el objetivo.',
          NO_VACANCY: 'Ya no tenemos vacantes activas.',
          ANOTHER_PROVIDER: 'Encontramos otro proveedor / plataforma.',
          COST: 'Costo / presupuesto.',
          OTHER: 'Otro',
        },
        COMMENT_LABEL: 'Comentarios:',
        COMMENT_PLACEHOLDER: 'Déjanos un comentario por favor.',
        CONTACT_US: '¿Quieres hablar con nosotros antes de irte?\nQuizá podamos ayudarte de otra manera.',
        CONTACT_EMAIL: 'Contacto',
        WHATSAPP_MESSAGE: 'Hola, me gustaría hablar con ustedes antes de dar de baja mi empresa.',
        WARNING_PERMANENT: 'Esta acción es permanente e irreversible.<br>Al dar de baja tu empresa se eliminarán todos los datos, ofertas y usuari@s asociados.',
        CONFIRM_CHECKBOX: 'Confirmo que entiendo que esta acción no se puede deshacer.',
        ACCEPT: 'Dar de baja',
        REJECT: 'Cancelar',
        CONFIRM_DIALOG: {
          HEADER: '¿Estás completamente segur@?',
          MESSAGE: '🔴 Una vez dada de baja tu empresa, <strong>no hay vuelta atrás.</strong><br>Perderás todos tus datos, ofertas y usuari@s asociad@s para siempre.',
          ACCEPT: 'Dar de baja definitivamente',
          REJECT: 'Cancelar',
        },
      },
    },
    LIST: {
      TITLE: 'Gestión de Empresas',
      FILTERS: {
        SEARCH: {
          PLACEHOLDER: 'Buscar empresa',
          SUBMIT: 'Buscar',
        },
        COUNTRY: 'País',
        SECTOR: 'Sector / Industria',
        DATE: 'ESTADO DE FECHAS',
        SIZE: 'Tamaño (Número de emplead@s)',
        STATUS: 'Estado',
      },
      TABLE: {
        HEADER: {
          LOGO: 'Logo',
          NAME: 'Nombre',
          SIZE: 'Tamaño',
          SECTOR: 'Sector',
          CITY: 'Ciudad',
          COUNTRY: 'País',
          ENABLED: 'Habilitada',
          DELETE: '',
          STATUS_ENTITY: 'Estado',
          FIRST_OFFER_DATE: 'Primera oferta',
          LAST_ACTIVITY: 'Última actividad',
          TOTAL_OFFERS: 'Ofertas totales',
          TOTAL_APPLY_OFFER: 'Solicitudes totales',
          AVERAGE_USERS_SUBSCRIBED: 'Usuari@s suscrit@s (prom.)',
          TOTAL_OFFERS_LAST_MONTH: 'Ofertas mes pasado',
          TOTAL_APPLY_OFFER_LAST_MONTH: 'Solicitudes mes pasado',
          AVERAGE_USERS_SUBSCRIBED_LAST_MONTH: 'Suscripciones (prom.) mes pasado',
        },
        ACTIONS: { DELETE: 'Eliminar Empresa' },
        NO_DATA: 'No hay empresas disponibles para la selección',
      },
      SUCCESS: {
        TITLE: 'Empresa actualizada correctamente.',
        TEXT: 'Los datos de la empresa se han actualizado correctamente.',
      },
    },
    USERS_LIST: {
      TITLE: 'Datos de la Empresa',
      SEE_MORE: 'Ver más',
      FILTERS: {
        SEARCH: {
          PLACEHOLDER: 'Buscar por nombre o email',
          SUBMIT: 'Buscar',
        },
      },
      TABLE: {
        HEADER: {
          AVATAR: 'Avatar',
          NAME: 'Nombre',
          EMAIL: 'Email',
          LOCALE: 'Idioma',
          GROUP: 'Rol',
          ENABLED: 'Habilitado',
        },
      },
      NO_DATA: 'No hay usuari@s en la empresa',
    },
    DISABLED: {
      TITLE: '¡Gracias por registrarte en wokap!',
      TAGLINE: 'En breve recibirás un correo con la respuesta a tu solicitud.</br> Revisa tu carpeta de spam (no deseados): algunos correos se filtran ahí por error.</br> Si tienes alguna duda mientras tanto, no dudes en contactarnos.',
      SUBTITLE: '¡Bienvenid@ a wokap!',
      ACTIONS: {
        LOGOUT: 'Cerrar sesión',
        DASHBOARD: 'Ir al dashboard',
        EXIT: 'Salir',
      },
    },
    DELETED: {
      TITLE: 'Tu empresa ha sido eliminada',
      SUBTITLE: 'Si crees que ha sido un error, por favor, ponte en contacto con nosotros en ',
      MAIL: 'saas@wokap.com',
    },
    SIZES: {
      MICRO: '1-9 emplead@s',
      SMALL: '10-49 emplead@s',
      MEDIUM: '50-249 emplead@s',
      LARGE: '250+ emplead@s',
    },
    SIZES_TABLE: {
      MICRO: '1-9',
      SMALL: '10-49',
      MEDIUM: '50-249',
      LARGE: '250+',
    },
    STATUS: {
      PARTIAL: 'Registro parcial',
      PENDING_ACTIVATED: 'Pendiente de activar',
      ACTIVE: 'Activa',
      INACTIVE: 'Inactiva',
    },
    ERRORS: {
      MEDIA_UPLOAD: 'Error al actualizar la imagen',
      INVALID_FORM: 'El formulario contiene errores, por favor complete todos los campos',
      FILE_NOT_BLANK: 'El archivo no puede estar vacío',
      FILE_MAX_SIZE: 'El archivo no puede pesar más de 50MB',
      FILE_MIME_TYPE_WRONG: 'El tipo de archivo es inválido',
      NAME_NOT_BLANK: 'El nombre no puede estar vacío',
      NAME_MIN_LENGTH: 'El nombre debe tener al menos 3 caracteres',
      NAME_MAX_LENGTH: 'El nombre no puede superar los 255 caracteres',
      BUSINESS_NAME_NOT_BLANK: 'El nombre de la empresa no puede estar vacío',
      BUSINESS_NAME_MIN_LENGTH: 'El nombre de la empresa debe tener al menos 3 caracteres',
      BUSINESS_NAME_MAX_LENGTH: 'El nombre de la empresa no puede superar los 255 caracteres',
      ADDRESS_NOT_BLANK: 'La dirección no puede estar vacía',
      ADDRESS_MIN_LENGTH: 'La dirección debe tener al menos 3 caracteres',
      ADDRESS_MAX_LENGTH: 'La dirección no puede superar los 255 caracteres',
      CITY_NOT_BLANK: 'La ciudad no puede estar vacía',
      CITY_MIN_LENGTH: 'El nombre de la ciudad debe tener al menos 3 caracteres',
      CITY_MAX_LENGTH: 'El nombre de la ciudad no puede superar los 255 caracteres',
      POSTAL_CODE_NOT_BLANK: 'El código postal no puede estar vacío',
      POSTAL_CODE_MIN_LENGTH: 'El código postal debe tener al menos 3 caracteres',
      POSTAL_CODE_MAX_LENGTH: 'El código postal no puede superar los 10 caracteres',
      STATE_NOT_BLANK: 'El estado no puede estar vacío',
      STATE_MIN_LENGTH: 'El nombre del estado debe tener al menos 3 caracteres',
      STATE_MAX_LENGTH: 'El nombre del estado no puede superar los 255 caracteres',
      COUNTRY_NOT_BLANK: 'El país no puede estar vacío',
      COUNTRY_MIN_LENGTH: 'El nombre del país debe tener al menos 1 carácter',
      COUNTRY_MAX_LENGTH: 'El nombre del país no puede superar los 255 caracteres',
      CIF_NOT_BLANK: 'El CIF no puede estar vacío',
      CIF_MIN_LENGTH: 'El CIF debe tener al menos 3 caracteres',
      CIF_MAX_LENGTH: 'El CIF no puede superar los 20 caracteres',
      PHONE_NOT_BLANK: 'El número de teléfono no puede estar vacío',
      PHONE_MIN_LENGTH: 'El número de teléfono debe tener al menos 3 caracteres',
      PHONE_MAX_LENGTH: 'El número de teléfono no puede superar los 20 caracteres',
      PHONE_INVALID: 'El número de teléfono no es válido, debe incluír el prefijo del país',
      EMAIL_NOT_BLANK: 'El correo electrónico no puede estar vacío',
      EMAIL_INVALID: 'El formato del correo electrónico es inválido',
      EMAIL_ALREADY_EXISTS: 'El correo electrónico ya está en uso',
      WEB_NOT_BLANK: 'El sitio web no puede estar vacío',
      WEB_MIN_LENGTH: 'La URL del sitio web debe tener al menos 3 caracteres',
      WEB_MAX_LENGTH: 'La URL del sitio web no puede superar los 255 caracteres',
      COMPANY_SIZE_NOT_BLANK: 'El tamaño de la empresa no puede estar vacío',
      COMPANY_SIZE_MIN_LENGTH: 'El tamaño de la empresa debe tener al menos 1 carácter',
      COMPANY_SIZE_MAX_LENGTH: 'El tamaño de la empresa no puede superar los 20 caracteres',
      DESCRIPTION_NOT_BLANK: 'La descripción no puede estar vacía',
      DESCRIPTION_MIN_LENGTH: 'La descripción debe tener al menos 10 caracteres',
      LEAST_MIN_ENTITY_LOCATIONS: 'Debe haber al menos una ubicación para la entidad',
      GREATER_MAX_ENTITY_LOCATIONS: 'No puede superar el máximo de 20 ubicaciones para la entidad',
      MEDIA_ENTITY_NOT_FOUND: 'La entidad de medios no se encontró',
      SECTOR_NOT_FOUND: 'El sector especificado no se encontró',
      ENTITY_NOT_FOUND: 'La empresa no se encontró',
      ZIP_CODE_INVALID: 'El código postal no es válido',
      IMAGE_MIME_TYPE_WRONG: 'El tipo de archivo de la imagen es inválido',
      IMAGE_MAX_SIZE: 'La imagen no puede pesar más de 10MB',
      ENTITY_LOCATION_NOT_REMOVED: 'No se puede eliminar la ubicación, ya que está asociada a una oferta de empleo',
      DUPLICATE_EMAIL: 'Uno o más responsables tienen direcciones de correo electrónico duplicadas. Por favor, asegúrate de que todas las direcciones de correo sean únicas.',
      ERROR_CREATING_ENTITY_RESPONSIBLES: 'Error al crear responsables de la empresa. Por favor, verifica que todas las direcciones de correo electrónico sean únicas.',
    },
  },
  DATA_MANAGEMENT: {
    TITLE: 'Configura tus datos',
    BREADCRUMB_TITLE: 'Configura tus datos',
    PHONE: 'Teléfono y extensión',
    WHATSAPP: 'WhatsApp',
    EMAIL: 'Email',
    LOCATION: 'Ubicación para entrevistas presenciales',
    VIRTUAL_LINK: 'Link para reuniones virtuales',
    SAVE: 'Guardar',
    CANCEL: 'Cancelar',
    SUCCESS: 'Datos guardados correctamente.',
    ERROR: 'Error al guardar los datos.',
    CALENDARS_TITLE: 'Calendarios',
    GOOGLE_CALENDAR_CONNECT: 'Conectar Google Calendar',
    GOOGLE_CALENDAR_CONNECTING: 'Conectando...',
    GOOGLE_CALENDAR_CONNECTED: 'Google Calendar conectado correctamente.',
    GOOGLE_CALENDAR_CONNECTED_EMAIL: 'Conectado con {{ email }}',
    GOOGLE_CALENDAR_DISCONNECT: 'Desconectar',
    GOOGLE_CALENDAR_DISCONNECTED: 'Google Calendar desconectado.',
    GOOGLE_CALENDAR_ERROR: 'Error al conectar Google Calendar.',
    OUTLOOK_CALENDAR_CONNECT: 'Conectar Outlook Calendar',
    OUTLOOK_CALENDAR_CONNECTING: 'Conectando...',
    OUTLOOK_CALENDAR_CONNECTED: 'Outlook Calendar conectado correctamente.',
    OUTLOOK_CALENDAR_CONNECTED_EMAIL: 'Conectado con {{ email }}',
    OUTLOOK_CALENDAR_DISCONNECT: 'Desconectar',
    OUTLOOK_CALENDAR_DISCONNECTED: 'Outlook Calendar desconectado.',
    OUTLOOK_CALENDAR_ERROR: 'Error al conectar Outlook Calendar.',
    CALENDAR_CONNECTED: 'Calendario conectado correctamente.',
    CALENDAR_ERROR: 'Error al conectar el calendario.',
    ICLOUD_CALENDAR_CONNECT: 'Conectar iCloud Calendar',
    ICLOUD_CALENDAR_CONNECTING: 'Conectando...',
    ICLOUD_CALENDAR_CONNECTED: 'iCloud Calendar conectado correctamente.',
    ICLOUD_CALENDAR_CONNECTED_EMAIL: 'Conectado con {{ email }}',
    ICLOUD_CALENDAR_DISCONNECT: 'Desconectar',
    ICLOUD_CALENDAR_DISCONNECTED: 'iCloud Calendar desconectado.',
    ICLOUD_CALENDAR_ERROR: 'Error al conectar iCloud Calendar.',
    ICLOUD_CALENDAR_INSTRUCTIONS_TITLE: '¿Cómo conectar iCloud Calendar?',
    ICLOUD_CALENDAR_DIALOG_SUBTITLE: 'Conecta tu calendario de iCloud para agendar entrevistas automáticamente.',
    ICLOUD_CALENDAR_INSTRUCTIONS_STEP1: '1. Entra a appleid.apple.com e inicia sesión.',
    ICLOUD_CALENDAR_INSTRUCTIONS_STEP2: '2. Ve a "Inicio de sesión y seguridad" → "Contraseñas específicas de apps".',
    ICLOUD_CALENDAR_INSTRUCTIONS_STEP3: '3. Genera una contraseña con el nombre "Wokap" y cópiala.',
    ICLOUD_CALENDAR_INSTRUCTIONS_WARNING: '⚠️ Esta NO es tu contraseña habitual de Apple ID.',
    ICLOUD_CALENDAR_APPLE_ID_LABEL: 'Apple ID (email)',
    ICLOUD_CALENDAR_APP_PASSWORD_LABEL: 'Contraseña de aplicación',
    ICLOUD_CALENDAR_CONNECT_BUTTON: 'Conectar',
    ICLOUD_CALENDAR_CANCEL_BUTTON: 'Cancelar',
  },
} as const;
